import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';

const DashboardParkingCapacitiesWidget = ({ data }) => {
  const [activeParking, setActiveParking] = useState(0);

  const parking = data[activeParking];
  parking.days = Object.values(parking.days);

  var barChartData = {
    labels: parking.days.map(day => day.day),
    datasets: [
      {
        label: 'Dagsticker Uitgeleend',
        backgroundColor: '#004D40',
        stack: 'dagsticker',
        data: parking.days.map(day => day.day_stickers_claimed)
      },
      {
        label: 'Dagsticker Aangevraagd',
        backgroundColor: '#00897B',
        stack: 'dagsticker',
        data: parking.days.map(
          day => day.day_stickers_requested - day.day_stickers_claimed
        )
      },
      {
        label: 'Dagsticker Beschikbaar',
        backgroundColor: '#4DB6AC',
        stack: 'dagsticker',
        data: parking.days.map(
          day => day.day_stickers_capacity - day.day_stickers_requested
        )
      },
      {
        label: 'Combisticker Uitgeleend',
        backgroundColor: '#0D47A1',
        stack: 'Combisticker',
        data: parking.days.map(day => day.combi_stickers_claimed)
      },
      {
        label: 'Combisticker Aangevraagd',
        backgroundColor: '#1E88E5',
        stack: 'Combisticker',
        data: parking.days.map(
          day => day.combi_stickers_requested - day.combi_stickers_claimed
        )
      },
      {
        label: 'Combisticker Beschikbaar',
        backgroundColor: '#64B5F6',
        stack: 'Combisticker',
        data: parking.days.map(
          day => day.combi_stickers_capacity - day.combi_stickers_requested
        )
      },
      {
        label: 'Totaal Uitgeleend',
        backgroundColor: '#BF360C',
        stack: 'Totaal',
        data: parking.days.map(day => day.total_claimed)
      },
      {
        label: 'Totaal Aangevraagd',
        backgroundColor: '#F4511E',
        stack: 'Totaal',
        data: parking.days.map(day => day.total_requested - day.total_claimed)
      },
      {
        label: 'Totaal Beschikbaar',
        backgroundColor: '#FF8A65',
        stack: 'Totaal',
        data: parking.days.map(day => day.total_available)
      }
    ]
  };

  return (
    <div className="m-portlet">
      <div className="m-portlet__body">
        <select
          name=""
          id=""
          className="form-control m-input"
          value={activeParking}
          onChange={e => setActiveParking(parseInt(e.target.value))}
        >
          {data.map((parking, index) => (
            <option key={index} value={index}>
              {parking.name}
            </option>
          ))}
        </select>

        <Bar
          data={barChartData}
          options={{
            responsive: true,
            scales: {
              xAxes: [
                {
                  stacked: true
                }
              ],
              yAxes: [
                {
                  stacked: true
                }
              ]
            }
          }}
        />
      </div>
    </div>
  );
};

DashboardParkingCapacitiesWidget.propTypes = {};

export default DashboardParkingCapacitiesWidget;
